import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface MobileChatModeCtx {
  active: boolean;
  title: string;
  setMobileChatMode: (active: boolean, title?: string) => void;
}

const MobileChatModeContext = createContext<MobileChatModeCtx>({
  active: false,
  title: "",
  setMobileChatMode: () => {},
});

export const MobileChatModeProvider = ({ children }: { children: ReactNode }) => {
  const [active, setActive] = useState(false);
  const [title, setTitle] = useState("");

  const setMobileChatMode = useCallback((a: boolean, t?: string) => {
    setActive(a);
    setTitle(t ?? "");
  }, []);

  return (
    <MobileChatModeContext.Provider value={{ active, title, setMobileChatMode }}>
      {children}
    </MobileChatModeContext.Provider>
  );
};

export const useMobileChatMode = () => useContext(MobileChatModeContext);
